export default "__VITE_ASSET__ddJ0eCP5__"